import NotificationsService from './NotificationsService'

export default NotificationsService
